import type { ReactNode } from "react";

export type SwotChartCardProps = {
  readonly title: string;
  readonly subtitle?: string | undefined;
  readonly loading?: boolean | undefined;
  readonly error?: ReactNode | undefined;
  readonly children?: ReactNode | undefined;
};

export function SwotChartCard(props: SwotChartCardProps) {
  return (
    <section className="swot-chart-card" aria-busy={props.loading ? "true" : undefined}>
      <header className="swot-chart-card__header">
        <h3>{props.title}</h3>
        {props.subtitle ? <p>{props.subtitle}</p> : null}
      </header>
      {props.error ? <div className="swot-chart-card__error">{props.error}</div> : props.loading ? <div className="swot-chart-card__loading">Loading chart</div> : <div className="swot-chart-card__body">{props.children}</div>}
    </section>
  );
}
